<template>
  <v-container fluid class="pa-12" style="max-width: 1344px;">
    <v-row align="start" justify="center" class="px-12">
      <v-col cols="12">
        <v-card class="elevation-5">
          <v-card-title>New Worker</v-card-title>
          <v-container fluid class="ma-2">
            <form>
              <v-text-field
                v-model="fname"
                :error-messages="fnameErrors"
                :counter="100"
                label="First Name"
                required
                @input="$v.fname.$touch()"
                @blur="$v.fname.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="lname"
                :error-messages="lnameErrors"
                label="Last Name"
                :counter="100"
                required
                @input="$v.lname.$touch()"
                @blur="$v.lname.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="fin"
                :error-messages="finErrors"
                label="Fin Number / NRIC "
                :counter="50"
                @input="$v.fin.$touch()"
                @blur="$v.fin.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="attendencetagging"
                :error-messages="attendencetaggingErrors"
                label="Attendence Tagging Serial "
                :counter="100"
                @input="$v.attendencetagging.$touch()"
                @blur="$v.attendencetagging.$touch()"
              ></v-text-field>
              <v-select
                v-model="gender"
                :items="genders"
                :error-messages="genderErrors"
                label="Gender"
                required
                @change="$v.gender.$touch()"
                @blur="$v.gender.$touch()"
              ></v-select>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="dob"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dob"
                    label="Date Of Birth"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    :error-messages="dobErrors"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dob" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn text color="primary" @click="$refs.menu.save(dob)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
              <v-select
                v-model="nationality"
                :items="nationalities"
                :error-messages="nationalityErrors"
                label="Nationality"
                required
                @change="$v.nationality.$touch()"
                @blur="$v.nationality.$touch()"
              ></v-select>
              <v-text-field v-model="address" label="Address"></v-text-field>
              <v-text-field v-model="postal" label="Postal Code"></v-text-field>
              <v-text-field v-model="contact" label="Contact"></v-text-field>
              <v-text-field
                v-model="nokname"
                label="Next of Kin Name"
              ></v-text-field>
              <v-text-field
                v-model="nokaddress"
                label="Next of Kin address"
              ></v-text-field>
              <v-text-field
                v-model="nokpostal"
                label="Next of Kin postal"
              ></v-text-field>
              <v-select
                v-model="workerstatusitem"
                :items="workerstatus"
                label="Worker Status"
                item-text="workerstatusname"
                item-value="workerstatusId"
                :error-messages="workerstatusErrors"
              ></v-select>
              <v-select
                v-model="workertype"
                :items="workertypes"
                label="Worker Type"
                item-text="workertypename"
                item-value="workertypeId"
                :error-messages="workertypeErrors"
              ></v-select>
              <v-menu
                ref="momapplicationmenu"
                v-model="momapplicationmenu"
                :close-on-content-click="false"
                :return-value.sync="momapplicationdate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="momapplicationdate"
                    label="MOM Application Date"
                    prepend-icon="event"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="momapplicationdate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="momapplicationmenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.momapplicationmenu.save(momapplicationdate)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
              <v-menu
                ref="startmenu"
                v-model="startmenu"
                :close-on-content-click="false"
                :return-value.sync="startdate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startdate"
                    label="Employed Dated"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="startdate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="startmenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.startmenu.save(startdate)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
              <v-menu
                ref="endmenu"
                v-model="endmenu"
                :close-on-content-click="false"
                :return-value.sync="enddate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="enddate"
                    label="Last Day Of Work"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="enddate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="endmenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.endmenu.save(enddate)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
              <v-textarea
                counter
                label="Remarks"
                v-model="remarks"
              ></v-textarea>
              <v-btn class="mr-4" color="primary" @click="submit">submit</v-btn>
              <v-btn @click="clear">clear</v-btn>
            </form>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import ApiService from '@/services/api.service'

export default {
  name: 'hr_new_worker',
  mixins: [validationMixin],

  validations: {
    fname: { required, maxLength: maxLength(100) },
    lname: { required, maxLength: maxLength(100) },
    fin: { maxLength: maxLength(50) },
    attendencetagging: { maxLength: maxLength(100) },
    email: { required, email },
    gender: { required },
    dob: { required },
    nationality: { required },
    workertype: { required },
    workerstatusitem: { required }
  },
  data: () => ({
    fname: '',
    lname: '',
    fin: '',
    attendencetagging: '',
    gender: null,
    dob: '',
    menu: null,
    startmenu: null,
    endmenu: null,
    momapplicationmenu: null,
    genders: ['Male', 'Female'],
    nationality: null,
    nationalities: [
      'Singaporean',
      'Indian',
      'Thai',
      'Afghan',
      'Albanian',
      'Algerian',
      'American',
      'Andorran',
      'Angolan',
      'Antiguans',
      'Argentinean',
      'Armenian',
      'Australian',
      'Austrian',
      'Azerbaijani',
      'Bahamian',
      'Bahraini',
      'Bangladeshi',
      'Barbadian',
      'Barbudans',
      'Batswana',
      'Belarusian',
      'Belgian',
      'Belizean',
      'Beninese',
      'Bhutanese',
      'Bolivian',
      'Bosnian',
      'Brazilian',
      'British',
      'Bruneian',
      'Bulgarian',
      'Burkinabe',
      'Burmese',
      'Burundian',
      'Cambodian',
      'Cameroonian',
      'Canadian',
      'Cape Verdean',
      'Central African',
      'Chadian',
      'Chilean',
      'Chinese',
      'Colombian',
      'Comoran',
      'Congolese',
      'Costa Rican',
      'Croatian',
      'Cuban',
      'Cypriot',
      'Czech',
      'Danish',
      'Djibouti',
      'Dominican',
      'Dutch',
      'East Timorese',
      'Ecuadorean',
      'Egyptian',
      'Emirian',
      'Equatorial Guinean',
      'Eritrean',
      'Estonian',
      'Ethiopian',
      'Fijian',
      'Filipino',
      'Finnish',
      'French',
      'Gabonese',
      'Gambian',
      'Georgian',
      'German',
      'Ghanaian',
      'Greek',
      'Grenadian',
      'Guatemalan',
      'Guinea-Bissauan',
      'Guinean',
      'Guyanese',
      'Haitian',
      'Herzegovinian',
      'Honduran',
      'Hungarian',
      'I-Kiribati',
      'Icelander',
      'Indonesian',
      'Iranian',
      'Iraqi',
      'Irish',
      'Israeli',
      'Italian',
      'Ivorian',
      'Jamaican',
      'Japanese',
      'Jordanian',
      'Kazakhstani',
      'Kenyan',
      'Kittian and Nevisian',
      'Kuwaiti',
      'Kyrgyz',
      'Laotian',
      'Latvian',
      'Lebanese',
      'Liberian',
      'Libyan',
      'Liechtensteiner',
      'Lithuanian',
      'Luxembourger',
      'Macedonian',
      'Malagasy',
      'Malawian',
      'Malaysian',
      'Maldivan',
      'Malian',
      'Maltese',
      'Marshallese',
      'Mauritanian',
      'Mauritian',
      'Mexican',
      'Micronesian',
      'Moldovan',
      'Monacan',
      'Mongolian',
      'Moroccan',
      'Mosotho',
      'Motswana',
      'Mozambican',
      'Namibian',
      'Nauruan',
      'Nepalese',
      'New Zealander',
      'Nicaraguan',
      'Nigerian',
      'Nigerien',
      'North Korean',
      'Northern Irish',
      'Norwegian',
      'Omani',
      'Pakistani',
      'Palauan',
      'Panamanian',
      'Papua New Guinean',
      'Paraguayan',
      'Peruvian',
      'Polish',
      'Portuguese',
      'Qatari',
      'Romanian',
      'Russian',
      'Rwandan',
      'Saint Lucian',
      'Salvadoran',
      'Samoan',
      'San Marinese',
      'Sao Tomean',
      'Saudi',
      'Scottish',
      'Senegalese',
      'Serbian',
      'Seychellois',
      'Sierra Leonean',
      'Slovakian',
      'Slovenian',
      'Solomon Islander',
      'Somali',
      'South African',
      'South Korean',
      'Spanish',
      'Sri Lankan',
      'Sudanese',
      'Surinamer',
      'Swazi',
      'Swedish',
      'Swiss',
      'Syrian',
      'Taiwanese',
      'Tajik',
      'Tanzanian',
      'Togolese',
      'Tongan',
      'Trinidadian/Tobagonian',
      'Tunisian',
      'Turkish',
      'Tuvaluan',
      'Ugandan',
      'Ukrainian',
      'Uruguayan',
      'Uzbekistani',
      'Venezuelan',
      'Vietnamese',
      'Welsh',
      'Yemenite',
      'Zambian',
      'Zimbabwean'
    ],
    address: '',
    postal: '',
    contact: '',
    remarks: '',
    startdate: '',
    enddate: '',
    nokname: '',
    nokaddress: '',
    nokpostal: '',
    workertype: '',
    workerstatusitem: '',
    momapplicationdate: '',
    workertypes: null,
    workerstatus: null
  }),
  computed: {
    fnameErrors() {
      const errors = []
      if (!this.$v.fname.$dirty) return errors
      !this.$v.fname.maxLength &&
        errors.push('First Name must be at most 100 characters long')
      !this.$v.fname.required && errors.push('First Name is required.')
      return errors
    },
    lnameErrors() {
      const errors = []
      if (!this.$v.lname.$dirty) return errors
      !this.$v.lname.maxLength &&
        errors.push('Last Name must be at most 100 characters long')
      !this.$v.lname.required && errors.push('Last Name is required.')
      return errors
    },
    finErrors() {
      const errors = []
      if (!this.$v.fin.$dirty) return errors
      !this.$v.fin.maxLength &&
        errors.push('Fin Name must be at most 50 characters long')
      return errors
    },
    attendencetaggingErrors() {
      const errors = []
      if (!this.$v.fin.$dirty) return errors
      !this.$v.fin.maxLength &&
        errors.push('Must be at most 100 characters long')
      return errors
    },
    genderErrors() {
      const errors = []
      if (!this.$v.gender.$dirty) return errors
      !this.$v.gender.required && errors.push('Gender is required')
      return errors
    },
    dobErrors() {
      const errors = []
      if (!this.$v.dob.$dirty) return errors
      !this.$v.dob.required && errors.push('Date of Birth is required')
      return errors
    },
    nationalityErrors() {
      const errors = []
      if (!this.$v.nationality.$dirty) return errors
      !this.$v.nationality.required && errors.push('Nationality is required')
      return errors
    },
    workertypeErrors() {
      const errors = []
      if (!this.$v.workertype.$dirty) return errors
      !this.$v.workertype.required && errors.push('Worker Type is required')
      return errors
    },
    workerstatusErrors() {
      const errors = []
      if (!this.$v.workertype.$dirty) return errors
      !this.$v.workertype.required && errors.push('Worker Status is required')
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      return errors
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.submitBtnLoading = true
      ApiService.get('/WorkerType')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workertypes = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
      ApiService.get('/WorkerStatus')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.workerstatus = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    submit() {
      this.$v.$touch()
      if (
        !this.$v.fname.$error &&
        !this.$v.lname.$error &&
        !this.$v.fin.$error &&
        !this.$v.attendencetagging.$error &&
        !this.$v.gender.$error &&
        !this.$v.dob.$error &&
        !this.$v.nationality.$error &&
        !this.$v.workerstatusitem.$error &&
        !this.$v.workertype.$error
      ) {
        let firstname = this.fname
        let lastname = this.lname
        let fin = this.fin
        let attendencetagging = this.attendencetagging
        let gender = this.gender
        let dob = this.dob
        let nationality = this.nationality
        let address = this.address
        let postal = this.postal
        let contact = this.contact
        let remarks = this.remarks
        let startdate = this.startdate
        let enddate = this.enddate
        let nokname = this.nokname
        let nokphone = this.nokphone
        let nokaddress = this.nokaddress
        let nokpostal = this.nokpostal
        let momapplicationdate = this.momapplicationdate
        let statusid = this.workerstatusitem
        let typeid = this.workertype

        ApiService.post('/Worker', {
          firstname,
          lastname,
          fin,
          attendencetagging,
          gender,
          dob,
          nationality,
          address,
          postal,
          contact,
          remarks,
          startdate,
          enddate,
          nokname,
          nokphone,
          nokaddress,
          nokpostal,
          momapplicationdate,
          statusid,
          typeid
        })
          .then(res => {
            if (res.data.success) {
              this.$v.$reset()
              this.fname = ''
              this.lname = ''
              this.fin = ''
              this.attendencetagging = ''
              this.gender = ''
              this.dob = ''
              this.nationality = ''
              this.address = ''
              this.postal = ''
              this.contact = ''
              this.remarks = ''
              this.startdate = ''
              this.enddate = ''
              this.nokname = ''
              this.nokaddress = ''
              this.nokpostal = ''
              this.workertype = ''
              this.workerstatusitem = ''
              this.workertype = ''
              this.$swal('', res.data.respond, 'success').then(function() {})
            } else {
              this.$swal('', res.data.error, 'error')
            }
          })
          .catch(() => {
            this.$swal('', 'Something Went wrong', 'error')
            this.loading = false
          })
      }
    },
    clear() {
      this.$v.$reset()
      this.fname = ''
      this.lname = ''
      this.fin = ''
      this.attendencetagging = ''
      this.gender = ''
      this.dob = ''
      this.nationality = ''
      this.address = ''
      this.postal = ''
      this.contact = ''
      this.remarks = ''
      this.startdate = ''
      this.enddate = ''
      this.nokname = ''
      this.nokaddress = ''
      this.nokpostal = ''
      this.workertype = ''
      this.workerstatusitem = ''
      this.workertype = ''
    }
  }
}
</script>
